import cn from 'classnames'

import { Button } from 'core-components/library/button'
import { IColumn } from 'core-components/library/list/types'
import { Tooltip } from 'core-components/library/tooltip'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'
import { IQBRDocumentsListItem } from 'partner360/models/qbr/IQBRDocumentsListItem'

import { IParsedObject } from '../../qbrDocumentsFilterArea/filters/QbrPartnersFilter'
import { DownloadDocumentAttachments } from '../components/qbrDocumentsTable/components/downloadDocumentAttachments/DownloadDocumentAttachments'
import styles from '../components/qbrDocumentsTable/QBRDocumentsTable.module.scss'

interface IGetColumns {
  isSuperAdmin: boolean
  userEmail: string
  setSelectedVersionToClone: (version: IQBRDocumentsListItem) => void
  setItemToDelete: (version: IQBRDocumentsListItem) => void
  openDocument: (document: IQBRDocumentsListItem) => void
}

export const getColumns = ({
  isSuperAdmin,
  userEmail,
  setSelectedVersionToClone,
  setItemToDelete,
  openDocument,
}: IGetColumns): IColumn<IQBRDocumentsListItem>[] => {
  return [
    {
      field: 'Name',
      title: TRANSLATION_KEYS.tableColumns.versionName,
      hideSettings: true,
      priority: 1,
    },
    {
      field: 'PartnerCount',
      title: TRANSLATION_KEYS.tableColumns.numberOfPartners,
      hideSettings: true,
      priority: 2,
      renderFunction: (item) => {
        const parsedArray: IParsedObject[] = item.PartnerIDs ? JSON.parse(item.PartnerIDs) : []
        return (
          <>
            <Tooltip
              className={styles.tooltip}
              tipContent={() => {
                return (
                  <div className={styles.countriesTooltip}>
                    {parsedArray.map((values, index) => {
                      return (
                        <p key={index}>
                          {values.PartnerID} : {values.PartnerName}
                        </p>
                      )
                    })}
                  </div>
                )
              }}
            >
              {item.PartnerCount}
            </Tooltip>
          </>
        )
      },
    },
    {
      field: 'FYearQuarter',
      title: TRANSLATION_KEYS.tableColumns.fyear,
      hideSettings: true,
      priority: 3,
    },
    {
      field: 'Region',
      title: TRANSLATION_KEYS.tableColumns.region,
      hideSettings: true,
      priority: 4,
      renderFunction: (item) => {
        return <div>{item.Region || '-'}</div>
      },
    },
    {
      field: 'Market',
      title: TRANSLATION_KEYS.tableColumns.market,
      hideSettings: true,
      priority: 5,
      renderFunction: (item) => {
        return <div>{item.Market || '-'}</div>
      },
    },
    {
      field: 'Settings',
      title: TRANSLATION_KEYS.tableColumns.netNdp,
      hideSettings: true,
      priority: 6,
      renderFunction: (item: IQBRDocumentsListItem) => {
        const settings = item.Settings ? JSON.parse(item.Settings) : {}
        return <div>{settings.SelectedNetNdp || '-'}</div>
      },
    },
    {
      field: 'Settings',
      title: TRANSLATION_KEYS.tableColumns.currency,
      hideSettings: true,
      priority: 7,
      renderFunction: (item: IQBRDocumentsListItem) => {
        const settings = item.Settings ? JSON.parse(item.Settings) : {}
        return <div>{settings.SelectedCurrency || '-'}</div>
      },
    },
    {
      field: 'Settings',
      title: TRANSLATION_KEYS.tableColumns.offerings,
      hideSettings: true,
      priority: 8,
      renderFunction: (item: IQBRDocumentsListItem) => {
        const settings = item.Settings ? JSON.parse(item.Settings) : {}
        const selectedOfferings = settings.SelectedOfferings || []
        const offeringValues = selectedOfferings.join(', ')
        return <div>{offeringValues || '-'}</div>
      },
    },
    {
      field: 'CreatedBy',
      title: TRANSLATION_KEYS.tableColumns.creator,
      hideSettings: true,
      priority: 9,
    },
    {
      field: 'Finalized',
      title: TRANSLATION_KEYS.tableColumns.status,
      hideSettings: true,
      priority: 10,
      renderFunction: (item) => {
        if (item.Finalized) {
          return <div>Y</div>
        }
        return <div>N</div>
      },
    },
    {
      field: 'IsLegacyDocument',
      title: TRANSLATION_KEYS.tableColumns.isLegacyDocument,
      hideSettings: true,
      priority: 10,
      renderFunction: (item) => {
        if (item.IsLegacyDocument) {
          return <div>Y</div>
        }
        return <div>N</div>
      },
    },
    {
      field: 'Btns',
      title: '',
      hideSettings: true,
      renderFunction: (item) => {
        const canBeDeleted = item.CreatedBy === userEmail || isSuperAdmin
        return (
          <div className={styles.actionButtons}>
            <Button className={styles.action} variant="text" onClick={() => openDocument(item)}>
              <i className="kbase kbase-edit" />
            </Button>
            <Button
              className={cn(styles.action)}
              variant="text"
              onClick={() => setSelectedVersionToClone(item)}
            >
              <i className="kbase kbase-copy" />
            </Button>
            <Button
              disabled={!canBeDeleted}
              className={styles.action}
              variant="text"
              onClick={() => setItemToDelete(item)}
            >
              <i className="kbase kbase-delete" />
            </Button>
            <DownloadDocumentAttachments documentEntryId={item.EntryId} />
          </div>
        )
      },
      priority: 12,
    },
  ]
}
